import { authenticatedAxios } from '../../utils/axios'
import CONSTANTS from '../../utils/constants'
import ENDPOINTS from '../constant'
import { updateCssVariables } from '../../utils/utils'
import { defaultPaltelTheme } from '../../assets/themes'

export const getFixedLineSOHOCustomerInfofromApi = async () => {
    let responseData = { data: {}, error: null }
    try {
      const res = await authenticatedAxios.post(
        `${ENDPOINTS.customerInfo.root}${ENDPOINTS.customerInfo.getFixedLineSohoCustomerInfo}`
      )
      if (res.data.responseCode === CONSTANTS.SUCCESS) {
        responseData.data = res.data
        let name = localStorage.setItem(
          'name',
          JSON.stringify(res.data.result.name)
        )
        if (name !== '' && name !== null) {
          localStorage.setItem('name', JSON.stringify(res.data.result.name))
        } else {
          localStorage.setItem('name', 'customer name')
        }
        let localTheme =
          res.data.result.theme.code === 'Theme1'
            ? defaultPaltelTheme
            : defaultPaltelTheme
  
        res.data.result.theme.lightMode = {
          ...localTheme.lightMode,
          ...res.data.result.theme.lightMode,
        }
        res.data.result.theme.darkMode = {
          ...localTheme.darkMode,
          ...res.data.result.theme.darkMode,
        }
  
        if (
          !localStorage.getItem('themeName') ||
          localStorage.getItem('themeName') !== res.data.result.theme.code
        ) {
          localStorage.setItem(
            'light',
            JSON.stringify(res.data.result.theme.lightMode)
          )
          localStorage.setItem(
            'dark',
            JSON.stringify(res.data.result.theme.darkMode)
          )
          updateCssVariables(res.data.result.theme.lightMode)
          localStorage.setItem('themeName', res.data.result.theme.code)
        }
      } else {
        responseData.error = res.data.responseMessage
      }
    } catch {
      responseData.error = 'General Error'
    }
    return responseData
  }

  export const getSOHOServicesFromApi = async () => {
    let responseData = {
      data: [],
      error: null,
    }
    try {
      const res = await authenticatedAxios.get(
        `${ENDPOINTS.fixedLineServices.root}${ENDPOINTS.fixedLineServices.getSOHOServices}`
      )
      if (res.data.responseCode === CONSTANTS.SUCCESS) {
        responseData.data = res.data.result
      } else if (res.data.responseCode === CONSTANTS.EMPTY_STATE) {
        responseData.data = res.data.result
      } else {
        responseData.error = res.data.responseMessage
      }
    } catch (error) {
      responseData.error = 'Error accrued while getting SOHO Services'
    }
    return responseData
  }

  export const getSOHOPlanDetails = async (data) => {
    let responseData = { planDetails: [], error: null }
    try {
      const res = await authenticatedAxios.post(
        `${ENDPOINTS.customerInfo.root}${ENDPOINTS.customerInfo.getSOHOPlanDetails}`,
        data
      )
  
      if (res.data.responseCode === CONSTANTS.SUCCESS) {
        responseData.planDetails = res.data.result
      } else {
        responseData.error = res.data.responseMessage
      }
    } catch {
      responseData.error = 'Error while getting plan details'
    }
    return responseData
  }